import { render, staticRenderFns } from "./localMenu.vue?vue&type=template&id=e5d78d64&"
import script from "./localMenu.vue?vue&type=script&lang=js&"
export * from "./localMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports